import { render } from "./UpdateUserProfilePic.vue?vue&type=template&id=a95711cc&ts=true"
import script from "./UpdateUserProfilePic.ts?vue&type=script&lang=ts&external"
export * from "./UpdateUserProfilePic.ts?vue&type=script&lang=ts&external"

import "./UpdateUserProfilePic.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__